import Vuex from 'vuex'
import Vue from 'vue'
import axios from 'axios'
import * as appConfigs from './configs'
import Cookies from 'js-cookie'
import { isEmpty, pick } from 'lodash'

Vue.use(Vuex)

const defaultState = {
	configs: [],
	prevStep: 0,
	step: 0,
	showScreenLoader: false,
	screenLoaderText: '',
	quoteRejected: false,
	showFaq: false,
	calculating: false,
	summaryData: {},
	accidentCover: null,
	error: '',
	errors: {},
	orderId: '',
	eFundResponse: null,
	usingCreditCard: false,
	showEmailBlock: false,
	customerEmail: '',
	showEndorsements: false,
	agreedToTerms: false,
	existingPendingOrder: null,
	selectedOccupation: null,
	stateByPostcode: null,
	agreedToDeclaration: true,
	underwriter: {}, // current underwriter
	pendingOrder: {},
	questionAnswers: [],
	unavailableOccupations: [],
	affiliate_id: null,
	agreedToPopupTerms: false,
	priceDetailsSize: 0,
}

export default new Vuex.Store({
	state: defaultState,
	actions: {
		loadConfigs (context) {
			Promise.all([
				axios.get(appConfigs.apiConfigsUrl),
				axios.get(appConfigs.getAllUnavailableOccupationsUrl)
			]).then(function ([ responseConfigs, responseOccupations ]) {
				context.commit('initConfigs', { configs: responseConfigs.data })
				context.commit('setUnavailableOccupations', { unavailableOccupations: responseOccupations.data.occupations })
			})
		},
		scrollToTop () {
			window.scroll(0, 50)
		},
		loadPendingOrder (context, { orderId, fields }) {
		//  console.log('%c Loading order %s ...', 'color: green;', orderId);

			return new Promise((resolve, reject) => {
				
				axios.get(appConfigs.checkPendingOrderExistsUrl + orderId)
					.then(({
						data = {}
					} = {}) => {
						console.log("=== data ===");
						console.log(data);
						if (!data.status) {
							Cookies.remove('pendingOrderId')
							reject()
						} else {
							axios.get(appConfigs.getPendingOrderUrl + orderId)
								.then(({
									data = {}
								} = {}) => {
									// console.log('%c Back from server %O', 'color: green;', data);
									context.commit('setPendingOrder', { pendingOrder: data })
									// context.commit('updateAccidentCover', { cover: data.accident_cover || null })
									context.commit('setUnderwriter', { underwriter: data.underwriter })

									resolve(fields ? pick(data, fields) : data)

								}).catch(() => {
									Cookies.remove('pendingOrderId')
									reject()
								})
						}
					}).catch(() => {
						reject()
					})
			})
		},
		loadOrder (context, { orderId }) {
			// console.log('%c Loading order %s ...', 'color: pink;', orderId);

			return new Promise((resolve, reject) => {
				axios.get(appConfigs.getOrderUrl + orderId)
					.then(({
						data = {}
					} = {}) => {
						// console.log('%c Back from server %O', 'color: pink;', data);
						if (data.status !== 'success') {
							reject()
						} else {
							context.commit('setUnderwriter', { underwriter: data.order.underwriter })
							resolve(data.order)
						}
					}).catch(() => {
						reject()
					})
			})
		},
		loadUnderwriters (context, fields) {
			// console.log('%c Loading underwriters %O ...', 'color: blue;', fields);
			return new Promise((resolve, reject) => {
				axios.post(appConfigs.underwritersUrl, fields, {timeout: 120000}).then(({
					data = {}
				} = {}) => {
					if (!data.status) {
						reject()
					} else {
						console.log('%c Back from server %O', 'color: blue;', data);
						resolve(data.providers)
					}
				}).catch(() => {
					reject()
				})
			})
		},
		loadQuestions (context, fields) {
			// console.log('%c Loading questions %O ...', 'color: pink;', fields);

			return new Promise((resolve, reject) => {
				axios.post(appConfigs.questionsUrl, fields, {timeout: 120000}).then(({
					data = {}
				} = {}) => {
					if (!data.status) {
						reject()
					} else {
						// console.log('%c Back from server %O', 'color: pink;', data);
						resolve(data.questions)
					}
				}).catch(() => {
					reject()
				})
			})
		},
		calculate (context, fields) {
			// console.log('%c Calculating %O ...', 'color: orange;', fields);
			return new Promise((resolve, reject) => {
				axios.post(appConfigs.pricingUrl, fields, {timeout: 120000}).then(({
					data = {}
				} = {}) => {
					resolve(data)
				}).catch(error => {
					reject(error)
				})
			})
		}
	},
	getters: {
		isExemptFromStampDuty: state => {
			return (
				(
					state.stateByPostcode === 'NSW' &&
					state.pendingOrder.current_annual_revenue < 2000000 &&
					state.agreedToDeclaration === true
				) ||
				state.stateByPostcode === 'ACT' ||
				state.stateByPostcode === 'TAS'
			)
		},
		totalCostOfInsurance: state => {
			if (isEmpty(state.summaryData)) {
				return 0
			}

			let total = state.summaryData.totalPrice
			// if (state.accidentCover) {
			// 	total += parseFloat(state.accidentCover.price)
			// }

			if (state.step == 5 && state.usingCreditCard) {
				// Charge = ( Pgoal + Sfixed) / (1 - Spercent)
				total = (total + appConfigs.stripeFixedSurcharge) / (1 - appConfigs.stripePercentageSurcharge)
			}

			return total
		},
		cheapestCostUnderwriterName: state => {
			if (isEmpty(state.summaryData)) {
				return null
			}
			let underwriter = state.summaryData.underwriterName
			return underwriter
		},
	},
	mutations: {
		initConfigs (state, payload) {
			state.configs = payload.configs
		},
		incrementStep (state) {
			state.prevStep = state.step
			state.step++
		},
		decrementStep (state) {
			state.prevStep = state.step
			state.step--
		},
		setUnavailableOccupations (state, payload) {
			state.unavailableOccupations = payload.unavailableOccupations
		},
		setStep (state, payload) {
			state.prevStep = state.step
			state.step = payload.step
		},
		setAgreedToPopupTerms (state, payload){
			state.agreedToPopupTerms = payload.agreedToPopupTerms
		},

		setFaq(state, payload){
			state.showFaq = payload.showFaq;
		},
		setScreenLoader(state, payload) {
			state.showScreenLoader = payload.showScreenLoader
		},
		setScreenLoaderText(state, payload){
			state.screenLoaderText = payload.screenLoaderText;
		},
		setQuoteRejected(state, payload) {
			state.quoteRejected = payload.quoteRejected
		},
		setCalculating(state, payload) {
			state.calculating = payload.calculating
		},
		setSummaryData(state, payload) {
			state.summaryData = payload.summaryData
		},
		setError(state, payload) {
			state.error = payload.error
		},
		clearError(state) {
			state.error = ''
		},
		setErrors(state, payload) {
			state.errors = payload.errors
		},
		resetState(state) {
			state = defaultState
		},
		setOrderId(state, payload) {
			// console.log(payload)
			state.orderId = payload.orderId
		},
		setEFundResponse(state, payload) {
			state.eFundResponse = payload.eFundResponse
		},
		setUsingCreditCard(state, { trueOrFalse }) {
			// console.log(trueOrFalse)
			state.usingCreditCard = trueOrFalse
		},
		toggleShowEndorsements(state) {
			state.showEndorsements = !state.showEndorsements
		},
		toggleShowEmailBlock(state, { trueOrFalse }) {
			// console.log(trueOrFalse)
			state.showEmailBlock = trueOrFalse
		},
		updateCustomerEmail(state, { email }) {
			state.customerEmail = email
		},
		setAgreedToTerms(state, { trueOrFalse }) {
			state.agreedToTerms = trueOrFalse
		},
		// updateAccidentCover(state, { cover }) {
		// 	state.accidentCover = cover
		// },
		updateExistingPendingOrderId(state, { existingPendingOrder }){
			state.existingPendingOrder = existingPendingOrder
		},
		updateSelectedOccupation(state, { selectedOccupation }) {
			state.selectedOccupation = selectedOccupation
		},
		updateStateByPostcode (state, { stateByPostcode }) {
			state.stateByPostcode = stateByPostcode
		},
		setAgreedToDeclaration (state, { trueOrFalse }) {
			state.agreedToDeclaration = trueOrFalse
		},
		setUnderwriter (state, { underwriter }) {
			state.underwriter = underwriter || {}
		},
		setPendingOrder (state, { pendingOrder }) {
			state.pendingOrder = pendingOrder || {}
		},
		setPriceDetailsSize(state, {size}){
			state.priceDetailsSize = size;
		}
	}

})
